export default "__VITE_ASSET__Divz51An__"